import Vue from 'vue'
import { decode, parsePath, withoutBase, withoutTrailingSlash, normalizeURL } from 'ufo'

import { getMatchedComponentsInstances, getChildrenComponentInstancesUsingFetch, promisify, globalHandleError, urlJoin, sanitizeComponent } from './utils'
import NuxtError from '../src/layouts/error.vue'
import NuxtLoading from './components/nuxt-loading.vue'

import '../src/assets/css/fonts.css'

const _2d217e9e = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/auth" */).then(m => sanitizeComponent(m.default || m))
const _332ce0fb = () => import('../src/layouts/combined.vue'  /* webpackChunkName: "layouts/combined" */).then(m => sanitizeComponent(m.default || m))
const _7ed9cc18 = () => import('../src/layouts/mobile.vue'  /* webpackChunkName: "layouts/mobile" */).then(m => sanitizeComponent(m.default || m))
const _6f6c098b = () => import('./layouts/default.vue'  /* webpackChunkName: "layouts/default" */).then(m => sanitizeComponent(m.default || m))
const _7363e3db = () => import('../src/layouts/combined.vue'  /* webpackChunkName: "layouts/2fuer1/combined" */).then(m => sanitizeComponent(m.default || m))
const _6697f210 = () => import('../src/layouts/mobile.vue'  /* webpackChunkName: "layouts/2fuer1/mobile" */).then(m => sanitizeComponent(m.default || m))
const _efe61d04 = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/2fuer1/auth" */).then(m => sanitizeComponent(m.default || m))
const _1d93291a = () => import('../src/layouts/combined.vue'  /* webpackChunkName: "layouts/bofrost/combined" */).then(m => sanitizeComponent(m.default || m))
const _2c339490 = () => import('../src/layouts/mobile.vue'  /* webpackChunkName: "layouts/bofrost/mobile" */).then(m => sanitizeComponent(m.default || m))
const _3cc30516 = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/bofrost/auth" */).then(m => sanitizeComponent(m.default || m))
const _b2920e02 = () => import('../src/layouts/combined.vue'  /* webpackChunkName: "layouts/cb/combined" */).then(m => sanitizeComponent(m.default || m))
const _2f52151c = () => import('../src/layouts/mobile.vue'  /* webpackChunkName: "layouts/cb/mobile" */).then(m => sanitizeComponent(m.default || m))
const _326038a2 = () => import('../src/themes/cb/layouts/auth.vue'  /* webpackChunkName: "layouts/cb/auth" */).then(m => sanitizeComponent(m.default || m))
const _1faac316 = () => import('../src/layouts/combined.vue'  /* webpackChunkName: "layouts/comma/combined" */).then(m => sanitizeComponent(m.default || m))
const _493ca012 = () => import('../src/layouts/mobile.vue'  /* webpackChunkName: "layouts/comma/mobile" */).then(m => sanitizeComponent(m.default || m))
const _503d0918 = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/comma/auth" */).then(m => sanitizeComponent(m.default || m))
const _7a5b7950 = () => import('../src/themes/compass/layouts/combined.js'  /* webpackChunkName: "layouts/compass/combined" */).then(m => sanitizeComponent(m.default || m))
const _563e21b5 = () => import('../src/themes/compass/layouts/combined.js'  /* webpackChunkName: "layouts/compass/mobile" */).then(m => sanitizeComponent(m.default || m))
const _19e8977b = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/compass/auth" */).then(m => sanitizeComponent(m.default || m))
const _2d44bd29 = () => import('../src/layouts/combined.vue'  /* webpackChunkName: "layouts/douglas/combined" */).then(m => sanitizeComponent(m.default || m))
const _4bf6dbc6 = () => import('../src/layouts/mobile.vue'  /* webpackChunkName: "layouts/douglas/mobile" */).then(m => sanitizeComponent(m.default || m))
const _4bfaa1cc = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/douglas/auth" */).then(m => sanitizeComponent(m.default || m))
const _0cee59ae = () => import('../src/themes/edeka/layouts/combined.js'  /* webpackChunkName: "layouts/edeka/combined" */).then(m => sanitizeComponent(m.default || m))
const _27f7d58b = () => import('../src/themes/edeka/layouts/combined.js'  /* webpackChunkName: "layouts/edeka/mobile" */).then(m => sanitizeComponent(m.default || m))
const _310948d1 = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/edeka/auth" */).then(m => sanitizeComponent(m.default || m))
const _33e9a9bd = () => import('../src/themes/edeka-suedwest/layouts/combined.vue'  /* webpackChunkName: "layouts/edeka-suedwest/combined" */).then(m => sanitizeComponent(m.default || m))
const _6e55dd5a = () => import('../src/themes/edeka-suedwest/layouts/combined.vue'  /* webpackChunkName: "layouts/edeka-suedwest/mobile" */).then(m => sanitizeComponent(m.default || m))
const _28d60f40 = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/edeka-suedwest/auth" */).then(m => sanitizeComponent(m.default || m))
const _9d68f82c = () => import('../src/themes/falktravel/layouts/combined.vue'  /* webpackChunkName: "layouts/falktravel/combined" */).then(m => sanitizeComponent(m.default || m))
const _ce5b4272 = () => import('../src/themes/falktravel/layouts/combined.vue'  /* webpackChunkName: "layouts/falktravel/mobile" */).then(m => sanitizeComponent(m.default || m))
const _47a61de6 = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/falktravel/auth" */).then(m => sanitizeComponent(m.default || m))
const _ee36952e = () => import('../src/themes/femotion/layouts/combined.js'  /* webpackChunkName: "layouts/femotion/combined" */).then(m => sanitizeComponent(m.default || m))
const _d89037f4 = () => import('../src/themes/femotion/layouts/combined.js'  /* webpackChunkName: "layouts/femotion/mobile" */).then(m => sanitizeComponent(m.default || m))
const _34e0ba0c = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/femotion/auth" */).then(m => sanitizeComponent(m.default || m))
const _0a0f0694 = () => import('../src/layouts/combined.vue'  /* webpackChunkName: "layouts/firstclass/combined" */).then(m => sanitizeComponent(m.default || m))
const _aa81cada = () => import('../src/layouts/mobile.vue'  /* webpackChunkName: "layouts/firstclass/mobile" */).then(m => sanitizeComponent(m.default || m))
const _396e2fd9 = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/firstclass/auth" */).then(m => sanitizeComponent(m.default || m))
const _22c775d0 = () => import('../src/themes/focus-deals/layouts/combined.js'  /* webpackChunkName: "layouts/focus-deals/combined" */).then(m => sanitizeComponent(m.default || m))
const _7c1d9375 = () => import('../src/themes/focus-deals/layouts/combined.js'  /* webpackChunkName: "layouts/focus-deals/mobile" */).then(m => sanitizeComponent(m.default || m))
const _bf0d0d8a = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/focus-deals/auth" */).then(m => sanitizeComponent(m.default || m))
const _b235405e = () => import('../src/themes/incent/layouts/combined.js'  /* webpackChunkName: "layouts/incent/combined" */).then(m => sanitizeComponent(m.default || m))
const _a19fef24 = () => import('../src/themes/incent/layouts/combined.js'  /* webpackChunkName: "layouts/incent/mobile" */).then(m => sanitizeComponent(m.default || m))
const _5966d874 = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/incent/auth" */).then(m => sanitizeComponent(m.default || m))
const _07e92775 = () => import('../src/layouts/combined.vue'  /* webpackChunkName: "layouts/kmw/combined" */).then(m => sanitizeComponent(m.default || m))
const _21096912 = () => import('../src/layouts/mobile.vue'  /* webpackChunkName: "layouts/kmw/mobile" */).then(m => sanitizeComponent(m.default || m))
const _16a81218 = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/kmw/auth" */).then(m => sanitizeComponent(m.default || m))
const _43e7bb48 = () => import('../src/themes/kurzinurlaub/layouts/combined.vue'  /* webpackChunkName: "layouts/kurzinurlaub/combined" */).then(m => sanitizeComponent(m.default || m))
const _6d9e54b6 = () => import('../src/themes/kurzinurlaub/layouts/combined.vue'  /* webpackChunkName: "layouts/kurzinurlaub/mobile" */).then(m => sanitizeComponent(m.default || m))
const _e650f12a = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/kurzinurlaub/auth" */).then(m => sanitizeComponent(m.default || m))
const _ac25a93c = () => import('../src/layouts/combined.vue'  /* webpackChunkName: "layouts/liebeskind/combined" */).then(m => sanitizeComponent(m.default || m))
const _dbb0f782 = () => import('../src/layouts/mobile.vue'  /* webpackChunkName: "layouts/liebeskind/mobile" */).then(m => sanitizeComponent(m.default || m))
const _6e05d6f6 = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/liebeskind/auth" */).then(m => sanitizeComponent(m.default || m))
const _54069e14 = () => import('../src/themes/marktkaufreisen/layouts/combined.vue'  /* webpackChunkName: "layouts/marktkaufreisen/combined" */).then(m => sanitizeComponent(m.default || m))
const _35c35ed3 = () => import('../src/themes/marktkaufreisen/layouts/combined.vue'  /* webpackChunkName: "layouts/marktkaufreisen/mobile" */).then(m => sanitizeComponent(m.default || m))
const _d592f7ce = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/marktkaufreisen/auth" */).then(m => sanitizeComponent(m.default || m))
const _9ea9ab6e = () => import('../src/themes/mivo/layouts/combined.js'  /* webpackChunkName: "layouts/mivo/combined" */).then(m => sanitizeComponent(m.default || m))
const _2b53de34 = () => import('../src/themes/mivo/layouts/combined.js'  /* webpackChunkName: "layouts/mivo/mobile" */).then(m => sanitizeComponent(m.default || m))
const _7ce49eec = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/mivo/auth" */).then(m => sanitizeComponent(m.default || m))
const _51084da8 = () => import('../src/themes/netto-discount/layouts/combined.vue'  /* webpackChunkName: "layouts/netto-discount/combined" */).then(m => sanitizeComponent(m.default || m))
const _08128005 = () => import('../src/themes/netto-discount/layouts/combined.vue'  /* webpackChunkName: "layouts/netto-discount/mobile" */).then(m => sanitizeComponent(m.default || m))
const _2ae049cb = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/netto-discount/auth" */).then(m => sanitizeComponent(m.default || m))
const _20412a16 = () => import('../src/themes/nettovorteilswelt/layouts/combined.vue'  /* webpackChunkName: "layouts/nettovorteilswelt/combined" */).then(m => sanitizeComponent(m.default || m))
const _d9d8c01a = () => import('../src/themes/nettovorteilswelt/layouts/combined.vue'  /* webpackChunkName: "layouts/nettovorteilswelt/mobile" */).then(m => sanitizeComponent(m.default || m))
const _65e48d39 = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/nettovorteilswelt/auth" */).then(m => sanitizeComponent(m.default || m))
const _69aaf9b6 = () => import('../src/layouts/combined.vue'  /* webpackChunkName: "layouts/norma/combined" */).then(m => sanitizeComponent(m.default || m))
const _634df0c2 = () => import('../src/layouts/mobile.vue'  /* webpackChunkName: "layouts/norma/mobile" */).then(m => sanitizeComponent(m.default || m))
const _526a7470 = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/norma/auth" */).then(m => sanitizeComponent(m.default || m))
const _5e94a781 = () => import('../src/themes/reisereporter/layouts/combined.js'  /* webpackChunkName: "layouts/reisereporter/combined" */).then(m => sanitizeComponent(m.default || m))
const _7f2507c4 = () => import('../src/themes/reisereporter/layouts/combined.js'  /* webpackChunkName: "layouts/reisereporter/mobile" */).then(m => sanitizeComponent(m.default || m))
const _2c650fb8 = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/reisereporter/auth" */).then(m => sanitizeComponent(m.default || m))
const _3ac88927 = () => import('../src/layouts/combined.vue'  /* webpackChunkName: "layouts/schlemmerauszeit/combined" */).then(m => sanitizeComponent(m.default || m))
const _b14ce178 = () => import('../src/layouts/mobile.vue'  /* webpackChunkName: "layouts/schlemmerauszeit/mobile" */).then(m => sanitizeComponent(m.default || m))
const _06d01cca = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/schlemmerauszeit/auth" */).then(m => sanitizeComponent(m.default || m))
const _0576f980 = () => import('../src/layouts/combined.vue'  /* webpackChunkName: "layouts/soliver/combined" */).then(m => sanitizeComponent(m.default || m))
const _3ee188c6 = () => import('../src/layouts/mobile.vue'  /* webpackChunkName: "layouts/soliver/mobile" */).then(m => sanitizeComponent(m.default || m))
const _32070b63 = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/soliver/auth" */).then(m => sanitizeComponent(m.default || m))
const _074fa8b6 = () => import('../src/themes/urlaubsguru/layouts/combined.vue'  /* webpackChunkName: "layouts/urlaubsguru/combined" */).then(m => sanitizeComponent(m.default || m))
const _06688d7c = () => import('../src/themes/urlaubsguru/layouts/combined.vue'  /* webpackChunkName: "layouts/urlaubsguru/mobile" */).then(m => sanitizeComponent(m.default || m))
const _23bea370 = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/urlaubsguru/auth" */).then(m => sanitizeComponent(m.default || m))
const _9d576946 = () => import('../src/themes/urlaubspiraten/layouts/combined.vue'  /* webpackChunkName: "layouts/urlaubspiraten/combined" */).then(m => sanitizeComponent(m.default || m))
const _e987320c = () => import('../src/themes/urlaubspiraten/layouts/combined.vue'  /* webpackChunkName: "layouts/urlaubspiraten/mobile" */).then(m => sanitizeComponent(m.default || m))
const _b45d2c00 = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/urlaubspiraten/auth" */).then(m => sanitizeComponent(m.default || m))
const _28e425f8 = () => import('../src/themes/veepee/layouts/combined.js'  /* webpackChunkName: "layouts/veepee/combined" */).then(m => sanitizeComponent(m.default || m))
const _3a1f733e = () => import('../src/themes/veepee/layouts/combined.js'  /* webpackChunkName: "layouts/veepee/mobile" */).then(m => sanitizeComponent(m.default || m))
const _081811b2 = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/veepee/auth" */).then(m => sanitizeComponent(m.default || m))
const _89ab436c = () => import('../src/themes/weserkurier/layouts/combined.vue'  /* webpackChunkName: "layouts/weserkurier/combined" */).then(m => sanitizeComponent(m.default || m))
const _01375db2 = () => import('../src/themes/weserkurier/layouts/mobile.js'  /* webpackChunkName: "layouts/weserkurier/mobile" */).then(m => sanitizeComponent(m.default || m))
const _3d500926 = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/weserkurier/auth" */).then(m => sanitizeComponent(m.default || m))
const _7abc9dfa = () => import('../src/layouts/combined.vue'  /* webpackChunkName: "layouts/wunschgutschein/combined" */).then(m => sanitizeComponent(m.default || m))
const _24e2bcd7 = () => import('../src/layouts/mobile.vue'  /* webpackChunkName: "layouts/wunschgutschein/mobile" */).then(m => sanitizeComponent(m.default || m))
const _11dd931d = () => import('../src/layouts/auth.vue'  /* webpackChunkName: "layouts/wunschgutschein/auth" */).then(m => sanitizeComponent(m.default || m))

let resolvedLayouts = {}
const layouts = { "_auth": _2d217e9e,"_combined": _332ce0fb,"_mobile": _7ed9cc18,"_default": _6f6c098b,"_2fuer1/combined": _7363e3db,"_2fuer1/mobile": _6697f210,"_2fuer1/auth": _efe61d04,"_bofrost/combined": _1d93291a,"_bofrost/mobile": _2c339490,"_bofrost/auth": _3cc30516,"_cb/combined": _b2920e02,"_cb/mobile": _2f52151c,"_cb/auth": _326038a2,"_comma/combined": _1faac316,"_comma/mobile": _493ca012,"_comma/auth": _503d0918,"_compass/combined": _7a5b7950,"_compass/mobile": _563e21b5,"_compass/auth": _19e8977b,"_douglas/combined": _2d44bd29,"_douglas/mobile": _4bf6dbc6,"_douglas/auth": _4bfaa1cc,"_edeka/combined": _0cee59ae,"_edeka/mobile": _27f7d58b,"_edeka/auth": _310948d1,"_edeka-suedwest/combined": _33e9a9bd,"_edeka-suedwest/mobile": _6e55dd5a,"_edeka-suedwest/auth": _28d60f40,"_falktravel/combined": _9d68f82c,"_falktravel/mobile": _ce5b4272,"_falktravel/auth": _47a61de6,"_femotion/combined": _ee36952e,"_femotion/mobile": _d89037f4,"_femotion/auth": _34e0ba0c,"_firstclass/combined": _0a0f0694,"_firstclass/mobile": _aa81cada,"_firstclass/auth": _396e2fd9,"_focus-deals/combined": _22c775d0,"_focus-deals/mobile": _7c1d9375,"_focus-deals/auth": _bf0d0d8a,"_incent/combined": _b235405e,"_incent/mobile": _a19fef24,"_incent/auth": _5966d874,"_kmw/combined": _07e92775,"_kmw/mobile": _21096912,"_kmw/auth": _16a81218,"_kurzinurlaub/combined": _43e7bb48,"_kurzinurlaub/mobile": _6d9e54b6,"_kurzinurlaub/auth": _e650f12a,"_liebeskind/combined": _ac25a93c,"_liebeskind/mobile": _dbb0f782,"_liebeskind/auth": _6e05d6f6,"_marktkaufreisen/combined": _54069e14,"_marktkaufreisen/mobile": _35c35ed3,"_marktkaufreisen/auth": _d592f7ce,"_mivo/combined": _9ea9ab6e,"_mivo/mobile": _2b53de34,"_mivo/auth": _7ce49eec,"_netto-discount/combined": _51084da8,"_netto-discount/mobile": _08128005,"_netto-discount/auth": _2ae049cb,"_nettovorteilswelt/combined": _20412a16,"_nettovorteilswelt/mobile": _d9d8c01a,"_nettovorteilswelt/auth": _65e48d39,"_norma/combined": _69aaf9b6,"_norma/mobile": _634df0c2,"_norma/auth": _526a7470,"_reisereporter/combined": _5e94a781,"_reisereporter/mobile": _7f2507c4,"_reisereporter/auth": _2c650fb8,"_schlemmerauszeit/combined": _3ac88927,"_schlemmerauszeit/mobile": _b14ce178,"_schlemmerauszeit/auth": _06d01cca,"_soliver/combined": _0576f980,"_soliver/mobile": _3ee188c6,"_soliver/auth": _32070b63,"_urlaubsguru/combined": _074fa8b6,"_urlaubsguru/mobile": _06688d7c,"_urlaubsguru/auth": _23bea370,"_urlaubspiraten/combined": _9d576946,"_urlaubspiraten/mobile": _e987320c,"_urlaubspiraten/auth": _b45d2c00,"_veepee/combined": _28e425f8,"_veepee/mobile": _3a1f733e,"_veepee/auth": _081811b2,"_weserkurier/combined": _89ab436c,"_weserkurier/mobile": _01375db2,"_weserkurier/auth": _3d500926,"_wunschgutschein/combined": _7abc9dfa,"_wunschgutschein/mobile": _24e2bcd7,"_wunschgutschein/auth": _11dd931d }

export default {
  render (h, props) {
    const loadingEl = h('NuxtLoading', { ref: 'loading' })

    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [layoutEl])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter (el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(() => {
            window.$nuxt.$emit('triggerScroll')
          })
        }
      }
    }, [templateEl])

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [
      loadingEl,

      transitionEl
    ])
  },

  data: () => ({
    isOnline: true,

    layout: null,
    layoutName: '',

    nbFetching: 0
    }),

  beforeCreate () {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created () {
    // Add this.$nuxt in child instances
    this.$root.$options.$nuxt = this

    if (process.client) {
      // add to window so we can listen when ready
      window.$nuxt = this

      this.refreshOnlineStatus()
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus)
      window.addEventListener('offline', this.refreshOnlineStatus)
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
    // Add $nuxt.context
    this.context = this.$options.context
  },

  async mounted () {
    this.$loading = this.$refs.loading
  },

  watch: {
    'nuxt.err': 'errorChanged'
  },

  computed: {
    isOffline () {
      return !this.isOnline
    },

    isFetching () {
      return this.nbFetching > 0
    },
  },

  methods: {
    refreshOnlineStatus () {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true
        } else {
          this.isOnline = window.navigator.onLine
        }
      }
    },

    async refresh () {
      const pages = getMatchedComponentsInstances(this.$route)

      if (!pages.length) {
        return
      }
      this.$loading.start()

      const promises = pages.map(async (page) => {
        let p = []

        // Old fetch
        if (page.$options.fetch && page.$options.fetch.length) {
          p.push(promisify(page.$options.fetch, this.context))
        }

        if (page.$options.asyncData) {
          p.push(
            promisify(page.$options.asyncData, this.context)
              .then((newData) => {
                for (const key in newData) {
                  Vue.set(page.$data, key, newData[key])
                }
              })
          )
        }

        // Wait for asyncData & old fetch to finish
        await Promise.all(p)
        // Cleanup refs
        p = []

        if (page.$fetch) {
          p.push(page.$fetch())
        }
        // Get all component instance to call $fetch
        for (const component of getChildrenComponentInstancesUsingFetch(page.$vnode.componentInstance)) {
          p.push(component.$fetch())
        }

        return Promise.all(p)
      })
      try {
        await Promise.all(promises)
      } catch (error) {
        this.$loading.fail(error)
        globalHandleError(error)
        this.error(error)
      }
      this.$loading.finish()
    },
    async errorChanged () {
      if (this.nuxt.err) {
        if (this.$loading) {
          if (this.$loading.fail) {
            this.$loading.fail(this.nuxt.err)
          }
          if (this.$loading.finish) {
            this.$loading.finish()
          }
        }

        let errorLayout = (NuxtError.options || NuxtError).layout;

        if (typeof errorLayout === 'function') {
          errorLayout = errorLayout(this.context)
        }

        await this.loadLayout(errorLayout)

        this.nuxt.errPageReady = true
        this.setLayout(errorLayout)
      }
    },

    setLayout (layout) {
      if (!layout || !resolvedLayouts['_' + layout]) {
        layout = 'default'
      }
      this.layoutName = layout
      let _layout = '_' + layout
      this.layout = resolvedLayouts[_layout]
      return this.layout
    },
    loadLayout (layout) {
      const undef = !layout
      const nonexistent = !(layouts['_' + layout] || resolvedLayouts['_' + layout])
      let _layout = '_' + ((undef || nonexistent) ? 'default' : layout)
      if (resolvedLayouts[_layout]) {
        return Promise.resolve(resolvedLayouts[_layout])
      }
      return layouts[_layout]()
        .then((Component) => {
          resolvedLayouts[_layout] = Component
          delete layouts[_layout]
          return resolvedLayouts[_layout]
        })
        .catch((e) => {
          if (this.$nuxt) {
            return this.$nuxt.error({ statusCode: 500, message: e.message })
          }
        })
    },
  },

  components: {
    NuxtLoading
  }
}
